"use client";

import { TravelAgentLogo } from "components/layouts/Header/TravelAgentLogo";
import MobileSearchBoxLogicNew from "components/templates/HomePage/SearchSection/MobileSearchBoxLogicNew";
import SearchBoxLogicNew from "components/templates/HomePage/SearchSection/SearchBoxLogicNew";
import WhimstayContainerNew from "components/utilities/WhimstayContainerNew";
import { useWindowScrolledMoreThan } from "hooks/useWindowScrolledMoreThan";
import { useDisclosure } from "utils/hooks/useDisclosure";
import { HeaderMenuPill } from "./HeaderMenuPill";
export const SearchBox = () => {
  const scrolled = useWindowScrolledMoreThan(380);
  const {
    isOpen,
    onToggle,
    onClose
  } = useDisclosure(); // Mobile search box disclosure hook
  return <WhimstayContainerNew className={`${scrolled ? "!w-full !max-w-full !px-0" : "!px-6 lg:!px-0"}`} data-sentry-element="WhimstayContainerNew" data-sentry-component="SearchBox" data-sentry-source-file="SearchBox.tsx">
      <div className={`w-full max-w-full px-0 py-1.5 md:mx-auto ${scrolled ? "bg-primary-500 md:px-0 md:py-[18px] lg:px-10" : "md:px-4 md:py-4 lg:px-10 xl:!px-16"}`}>
        <WhimstayContainerNew className={`flex items-center justify-between gap-x-8 lg:!w-full lg:!px-0 ${scrolled ? "!px-6" : "!px-0 md:!px-4"}`} data-sentry-element="WhimstayContainerNew" data-sentry-source-file="SearchBox.tsx">
          {scrolled && <div className='hidden lg:block'>
              <TravelAgentLogo className='text-white' />
            </div>}
          <div className='flex-grow'>
            {/* Mobile Search */}
            <MobileSearchBoxLogicNew isOpen={isOpen} onToggle={onToggle} onClose={onClose} pageOrigin='home page' className='min-[981px]:hidden' data-sentry-element="MobileSearchBoxLogicNew" data-sentry-source-file="SearchBox.tsx" />

            <div className={`hidden w-full rounded-[64px] bg-white min-[981px]:block ${scrolled ? "animate-searchbox-zoom" : "p-2 shadow-[0_4px_20px_0_rgba(55,56,77,0.13)]"}`}>
              <SearchBoxLogicNew scrolled={scrolled} onToggle={onToggle} data-sentry-element="SearchBoxLogicNew" data-sentry-source-file="SearchBox.tsx" />
            </div>
          </div>
          {scrolled && <div className='hidden lg:flex'>
              <HeaderMenuPill />
            </div>}
        </WhimstayContainerNew>
      </div>
    </WhimstayContainerNew>;
};